"use strict";

import _classCallCheck from "/home/runner/work/gatsby-web3-starter/gatsby-web3-starter/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/gatsby-web3-starter/gatsby-web3-starter/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/gatsby-web3-starter/gatsby-web3-starter/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/gatsby-web3-starter/gatsby-web3-starter/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/gatsby-web3-starter/gatsby-web3-starter/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { arrayify, hexlify } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder"; // @TODO: Merge this with bytes

export var FixedBytesCoder = /*#__PURE__*/function (_Coder) {
  _inherits(FixedBytesCoder, _Coder);

  var _super = _createSuper(FixedBytesCoder);

  function FixedBytesCoder(size, localName) {
    var _this;

    _classCallCheck(this, FixedBytesCoder);

    var name = "bytes" + String(size);
    _this = _super.call(this, name, name, localName, false);
    _this.size = size;
    return _this;
  }

  _createClass(FixedBytesCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      var data = arrayify(value);

      if (data.length !== this.size) {
        this._throwError("incorrect data length", value);
      }

      return writer.writeBytes(data);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, hexlify(reader.readBytes(this.size)));
    }
  }]);

  return FixedBytesCoder;
}(Coder);